const { EProviderReplacementPaths, EProviderStates } = require('@sigmasms/shared-types')
const { upgradeArray } = require('../utils')
const enumToConstant = require('../utils/enumToConstant')

const PROVIDER_ACTIONS = upgradeArray([ 'send', 'check', 'ping' ])
const PROVIDER_STATUS = upgradeArray([ 'active', 'inactive', 'invalid' ])
const PUBLIC_FIELDS_PROVIDER = [ 'id', 'title', 'type', 'isActive' ]
const FULL_FIELDS_PROVIDER = [ 'id', 'title', 'type', 'settings', 'isActive', 'updatedAt', 'createdAt' ]

const PROVIDER_STATES = enumToConstant(EProviderStates)
const PROVIDER_MESSAGE_STATUS_CHECK_MODE = upgradeArray([ 'off', 'active', 'passive' ])
const PROVIDER_MODES = upgradeArray([ 'receiver', 'transmitter', 'transceiver' ])
const PROVIDER2_ACTIONS = upgradeArray([ 'sendMessage', 'checkMessageStatus', 'ping' ])

const PROVIDER_REPLACEMENT_PATHS = enumToConstant(EProviderReplacementPaths)

module.exports = {
  PROVIDER_ACTIONS,
  PROVIDER_STATUS,
  PUBLIC_FIELDS_PROVIDER,
  FULL_FIELDS_PROVIDER,
  PROVIDER_STATES,
  PROVIDER_MESSAGE_STATUS_CHECK_MODE,
  PROVIDER_MODES,
  PROVIDER2_ACTIONS,
  PROVIDER_REPLACEMENT_PATHS
}
